import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { createPortal } from 'react-dom';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  // Lock body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  // Handle escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [onClose]);
  return <AnimatePresence data-id="element-195">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" data-id="element-196">
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="absolute inset-0 bg-[#3D2B1F]/60 backdrop-blur-sm" aria-hidden="true" data-id="element-197" />

          {/* Modal Content */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.2,
        ease: 'easeOut'
      }} className="relative w-full max-w-2xl max-h-[85vh] flex flex-col bg-[#FAF6F0] rounded-2xl shadow-2xl border border-[#D4A89A]/30 overflow-hidden" role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-198">
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-[#3D2B1F]/10 bg-white/50" data-id="element-199">
              <h2 id="modal-title" className="text-xl font-serif font-bold text-[#3D2B1F]" data-id="element-200">
                {title}
              </h2>
              <button onClick={onClose} className="p-2 rounded-full text-[#3D2B1F]/60 hover:bg-[#3D2B1F]/5 hover:text-[#3D2B1F] transition-colors focus:outline-none focus:ring-2 focus:ring-[#B8845C]/50" aria-label="Cerrar" data-id="element-201">
                <X size={20} data-id="element-202" />
              </button>
            </div>

            {/* Body */}
            <div className="p-6 overflow-y-auto custom-scrollbar text-[#3D2B1F]/80 leading-relaxed space-y-4" data-id="element-203">
              {children}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}